import { getOrderCurrency } from '@app/ducks';
import { formatPriceWithCurrencyAffix } from '@app/logic/price';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  totalPrice: number;
  totalQuantity: number;
}

export const TotalsSummary = ({ totalPrice, totalQuantity }: Props) => {
  const { t } = useTranslation(['common']);
  const currency = useSelector(getOrderCurrency);

  return (
    <div className="ml-auto flex flex-col items-end whitespace-nowrap">
      <span className="body-1">{formatPriceWithCurrencyAffix(currency)(totalPrice)}</span>
      <span className="whitespace-nowrap text-neutral-60 body-4">
        {totalQuantity} {t('common:item', { count: totalQuantity })}
      </span>
    </div>
  );
};
